import React, {FC} from "react"

import {injectIntl, InjectIntl} from "@irati/utils/lang"
import {OrganisationalSummaryCategory} from "@irati/types"
import {IconTypes} from "@irati/ui/src/Icon"
import Tabs from "@irati/ui/src/Tabs"

interface Props extends InjectIntl {
  onChange: (category: OrganisationalSummaryCategory) => void
  selectedCategory: OrganisationalSummaryCategory
}

const Categories: FC<Props> = ({onChange, selectedCategory, formatMessage}) => {
  const getTabs = () => {
    return [
      {
        title: formatMessage({id: "admin.reporting.orgSummary.categories.keyTrends"}),
        key: OrganisationalSummaryCategory.Main,
        icon: IconTypes.all
      },
      {
        title: formatMessage({id: "admin.reporting.orgSummary.categories.perks"}),
        key: OrganisationalSummaryCategory.Perks,
        icon: IconTypes.perks
      },
      {
        title: formatMessage({id: "admin.reporting.orgSummary.categories.rewardsCelebrations"}),
        key: OrganisationalSummaryCategory.Celebrations,
        icon: IconTypes.celebration
      },
      {
        title: formatMessage({id: "admin.reporting.orgSummary.categories.wellness"}),
        key: OrganisationalSummaryCategory.Wellness,
        icon: IconTypes.wellness
      }
    ]
  }

  return (
    <Tabs
      addMarginTop
      unmountOnExit
      mountOnEnter
      secondary
      onSelect={(value) => onChange(value)}
      activeKey={selectedCategory}
      tabs={getTabs()}
    />
  )
}

export default injectIntl(Categories)
